import React, {Component} from "react";
import {ITEM_COUNT_PER_PAGE} from "../../../configuration";
import ProductionHeader from "./ProductionHeader";
import ProductionRow from "./ProductionRow";
import ProductionBottom from "./ProductionBottom";
import InquiryRow from "../Inquiry/InquiryRow/InquiryRow";
import {FormattedMessage} from "react-intl";
import './ProductionTable.css'

class ProductionTable extends Component {

    render() {
        let no = 1 + ((this.props.activePage - 1) * ITEM_COUNT_PER_PAGE);
        return (
            <div>
                <div className="admin-tables">

                    <div className="admin-table-row-content">
                        <table className="table table-bordered table-all-orders-resp">
                            <ProductionHeader/>

                           <tbody>
                           {this.props.items.length !== 0 ?
                               this.props.items.map(order => {
                                   return <ProductionRow key={order.id} order={order} no={no++}
                                                         getAll={this.props.getFilteredProducts}
                                                         getAllProduction={this.props.getAllProduction}/>;
                               }) :
                               <tr>
                                   <td colSpan={6}>
                                   <div className="text-center"><FormattedMessage id="app.no-records-found"
                                                                                  defaultMessage="ORDER"
                                                                                  description=""/></div>
                                    </td>
                               </tr>
                           }
                           </tbody>
                        </table>

                    </div>
                </div>

                <ProductionBottom activePage={this.props.activePage}
                                  itemsCountPerPage={ITEM_COUNT_PER_PAGE}
                                  totalItemsCount={this.props.totalItemCount}
                                  handlePageChange={this.props.handlePageChange}/>

            </div>
        );
    }
}

export default ProductionTable;



// WEBPACK FOOTER //
// ./src/components/Admin/ProductionCompletionList/ProductionTable.js